var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"labelSmall"}),(_vm.isRated)?_c('h4',{staticClass:"title"},[_vm._v("TWOJE POSIŁKI ZOSTAŁY OCENIONE")]):_c('h4',{staticClass:"title"},[_vm._v("NIE OCENIŁEŚ POSIŁKÓW")])])}
var staticRenderFns = []

export { render, staticRenderFns }